import { Vehicle } from "../../Interfaces/vehicle.type";
import getVehicleDataPush from "../getVehicleDataPush";

const vdpLinkDataPush = (vehicle: Vehicle) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "link",
        label: "vehicle-description",
        action: "navigate",
        section: "card",
      },
      ...vehicleDataPush,
    });
  }
};

export default vdpLinkDataPush;
